import type { Supplier } from '#shared/types';
import { Badge } from '#client/components/ui/Badge';
import type { Column } from '#client/components/ui/DataTable';
import { ResourceListPage } from '#client/components/ui/ResourceListPage';
import { RESOURCE } from '#client/lib/routes';
import { dash } from '#client/lib/format';

const columns: Column<Supplier>[] = [
  { key: 'name', header: 'Supplier', render: (row) => <strong>{row.name}</strong> },
  {
    key: 'code',
    header: 'Code',
    width: '120px',
    render: (row) => <span className="ident">{row.code}</span>,
  },
  { key: 'contact', header: 'Contact', render: (row) => dash(row.contact_name) },
  { key: 'phone', header: 'Phone', width: '160px', render: (row) => dash(row.phone_number) },
  {
    key: 'is_active',
    header: 'Status',
    width: '110px',
    render: (row) =>
      row.is_active ? <Badge tone="success">Active</Badge> : <Badge tone="neutral">Inactive</Badge>,
  },
];

export function SupplierListPage() {
  return (
    <ResourceListPage<Supplier>
      title="Suppliers"
      subtitle="Who the lab buys reagents from"
      path={RESOURCE.suppliers}
      columns={columns}
      noun="supplier"
      nounPlural="suppliers"
      searchPlaceholder="Search by name, code or contact"
      rowLabel={(row) => row.name}
      createCapability="supplier.create"
      editCapability="supplier.edit"
      deleteCapability="supplier.delete"
      emptyBody="A supplier is optional — stock can be entered without one — but recording it is what makes a batch traceable."
    />
  );
}
